module.exports = __webpack_public_path__ + "img/quiz-good.b8d18179.svg";